import { useState } from "react";
import Title from "../../extras/Title";
import PendingRequest from "./PendingRequest";
import AcceptRequest from "./AcceptRequest";
import RejectRequest from "./RejectRequest";
import Analytics from "../../extras/Analytics";
import MultiButton from "../../extras/MultiButton";

const ExpertRequest = () => {
    const [type, setType] = useState("pending")
    const [status, setStatus] = useState("1")
    const [startDate, setStartDate] = useState("ALL");
    const [endDate, setEndDate] = useState("ALL");
    const statusMapping = {
        "accepted": 2,
        "pending": 1,
        "declined": 3,
    }
    return (
        <div className="userPage">
            <div className="d-flex justify-content-between mb-3">
                <div className="multi-user-btn  ">
                    <MultiButton
                        multiButtonSelect={type}
                        setMultiButtonSelect={(value) => {
                            setType(value)
                            setStatus(statusMapping[value])
                        }}
                        label={["pending", "accepted", "declined"]}
                    />
                </div>
                <Analytics
                    analyticsStartDate={startDate}
                    analyticsStartEnd={endDate}
                    placeholder="Wallet"
                    analyticsStartDateSet={setStartDate}
                    analyticsStartEndSet={setEndDate}
                />
            </div>
            <div className="user-table mb-3">
                <div className="user-table-top">
                    <div className=" d-flex justify-content-between align-items-center w-100 ">
                        <div className="w-100">
                            <h5
                                className="main-title">
                                Expert Withdrawal Request
                            </h5>
                        </div>
                        
                    </div>
                </div>
              
              

                {
                    type === "pending" && (
                        <PendingRequest status={status} startDate={startDate} endDate={endDate} />
                    )
                }
                {
                    type === "accepted" && (
                        <AcceptRequest status={status} startDate={startDate} endDate={endDate} />
                    )
                }
                {
                    type === "declined" && (
                        <RejectRequest status={status} startDate={startDate} endDate={endDate} />
                    )
                }
            </div>


        </div>
    )
}
export default ExpertRequest;